import { render } from "./ExtrusionDiesView.vue?vue&type=template&id=edf3f9a4"
import script from "./ExtrusionDiesView.vue?vue&type=script&lang=js"
export * from "./ExtrusionDiesView.vue?vue&type=script&lang=js"

import "./ExtrusionDiesView.vue?vue&type=style&index=0&id=edf3f9a4&lang=scss"

import exportComponent from "/Users/mmessick/Sites/kiosk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__